import { render, staticRenderFns } from "./XsollaModal.vue?vue&type=template&id=7e5493fc&"
import script from "./XsollaModal.vue?vue&type=script&lang=js&"
export * from "./XsollaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports